import React from 'react';

import { getDeliveryWindowLabel } from '../deliveryWindows/scheduled-delivery-utils';
import { getEarliestOrderTimeMS, getLatestOrderTimeMS } from './timeslot-utils';
import PreviewSlot from './PreviewSlot';

import PropTypes from 'prop-types';

import styles from './SelectTimeSlot.module.css';

const SelectTimeSlotPreview = ({
  displayDayIdx,
  timeSlots=[],
  currentTimeMS
}) => {

  // Scroll first enabled slot into view
  React.useEffect(() => {
    if (timeSlots.length) {
      const firstEnabled = document.querySelector('div[class*="selectTimeSlot"] div[data-slot-enabled="true"]');
      if (firstEnabled?.scrollIntoView) {
        firstEnabled.scrollIntoView({behavior:'smooth', block:'center'});
      }
    }  
  }, [timeSlots, currentTimeMS]); 
  
  return (
    <div className={styles.selectTimeSlot}>
      { timeSlots.length 
         ? timeSlots.map((slot,idx) => {
            const slotCloseMS = getLatestOrderTimeMS(displayDayIdx, slot, currentTimeMS);
            const isExpired = slotCloseMS <= currentTimeMS;
            const slotOpenMS = getEarliestOrderTimeMS(displayDayIdx, slot, currentTimeMS);
            const isOpen = currentTimeMS >= slotOpenMS;
            
            const slotId = `day_${displayDayIdx}_slot_${idx}`;
            const isDisabled = isExpired || !isOpen;
            const slotLabel = getDeliveryWindowLabel(slot.hours);
        
            return (
              <PreviewSlot
                key={slotId}
                displayDayIdx={displayDayIdx}
                label={slotLabel}
                isDisabled={isDisabled}
                slotOpenMS={slotOpenMS}
                currentTimeMS={currentTimeMS} />
            )  
          })
        : null
      }
    </div>
  )
}

SelectTimeSlotPreview.propTypes = {
  displayDayIdx: PropTypes.number.isRequired,
  timeSlots: PropTypes.array.isRequired,
  currentTimeMS: PropTypes.number.isRequired
};

export default SelectTimeSlotPreview;